<template>
  <div class="box7">
    <pageTitle
      title="权威鸿蒙讲师 全程陪伴学习"
      text="拒绝盲目摸索，帮你构建鸿蒙晋级之路"
      titleColor="#000D4D"
      titColor="#5A628A"
    />

    <div class="teacher-box">
      <div class="box1" ref="content">
        <div class="tea-wrapper" v-for="(item, index) in teacherList.slice(0,5)" :key="index">
					<img :src="item.img1" alt="" />
					<div class="p-wrapper">
						<p class="text1">{{item.name}}</p>
						<p class="text2">{{item.tag1}}</p>
						<p class="text2">{{item.tag2}}</p>
					</div>
				</div>
      </div>
    </div>
    <div class="teacher-box teacher-box2">
      <div class="box2">
        <div class="tea-wrapper" v-for="(item, index) in teacherList.slice(5,9)" :key="index + '-1'">
					<img :src="item.img1" alt="" />
					<div class="p-wrapper">
						<p class="text1">{{item.name}}</p>
						<p class="text2">{{item.tag1}}</p>
						<p class="text2">{{item.tag2}}</p>
					</div>
				</div>
      </div>
      <!-- <div class="scorll-box">
        <div class="scorll-block" :style="styleVar"></div>
      </div> -->
    </div>
    <div class="seek-btn" @click="openDetail('查看老师履历')">
      查看老师履历
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import check from "../../../utils/check";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      cur: 0,
      show: false,

      teacherList: [
        {
          name: 'pink老师',
          tag1: '华为鸿蒙高级开发认证',
          tag2: '华为学堂认证讲师',
          img1: require('../../../assets/coursePage/harmony/box7/Pink老师-1.png'),
          skill: [
            '精通JavaScript/TypeScript/Vue/ArkTS/ArkUI等前端技术栈', 
            'B站知名UP主，视频播放超过3500万+，黑马pink讲前端粉丝54万+',
            '抖音号粉丝12万+'
          ],
          award: '《H5+C3前端基础》、《JavaScript核心与进阶》、《数据可视化开发》'
        },
        {
          name: '高老师',
          tag1: '华为鸿蒙高级开发认证',
          tag2: '黑马高级课程研究员',
          img1: require('../../../assets/coursePage/harmony/box7/高老师-1.png'),
          skill: [
            '精通Vue/UniApp/TypeScript/ArkTS/ArkUl/Ability组件等前端技术栈', 
            '曾任用友架构师，零编码/低代码设计专家',
            '抖音号“黑马前端大佬高”粉丝12W+'
          ],
          award: '神领物流APP鸿蒙版'
        },
        {
          name: '张老师',
          tag1: '华为鸿蒙高级开发认证',
          tag2: '黑马高级课程研究员',
          img1: require('../../../assets/coursePage/harmony/box7/张老师-1.png'),
          skill: [
            '精通Vue/React/uni-app/TypeScript/ArkTS/ArkUI等前端技术', 
            '曾任中国电信翼推送技术经理',
            '拥有软件+教资双证'
          ],
          award: '《鸿蒙端云一体化课程》、《 Next.js学成在线项目课程》'
        },
        {
          name: '赵老师',
          tag1: '华为鸿蒙高级开发认证',
          tag2: '黑马高级课程研究员',
          img1: require('../../../assets/coursePage/harmony/box7/赵老师-1.png'),
          skill: [
            '精通Vue/React/小程序/uni-app/TypeScript/ ArkTS / ArkUI等前端技术', 
            'B站《前端基础课程》播放量  370W+',
            'B站《HTML5 + CSS3 课程》播放量 90W+'
          ],
          award: '《HTML5+CSS3+ 移动web课程》'
        },
        {
          name: '胡老师',
          tag1: '华为鸿蒙高级开发认证',
          tag2: '华为开发者联盟认证讲师',
          img1: require('../../../assets/coursePage/harmony/box7/胡老师-1.png'),
          skill: [
            '精通Vue/React/小程序/uni-app/TypeScript/ ArkTS / ArkUI等前端技术', 
            'B站《4小时带你快速入门Vue》播放量  239W+',
            'B站《Ajax零基础入门》播放量 48W+'
          ],
          award: '《鸿蒙元服务课程》、《4小时带你快速入门Vue》、《Ajax零基础入门》'
        },
        // {
        //   name: '王老师',
        //   tag1: '华为鸿蒙高级开发认证',
        //   tag2: '跨端可视化数据埋点专利',
        //   img1: require('../../../assets/coursePage/harmony/box7/王老师-1.png'),
        //   skill: [
        //     '精通Vue/React/小程序/uni-app/TypeScript/ ArkTS / ArkUI等前端技术', 
        //   ],
        //   award: '《鸿蒙翼康养老互联网项目》、国内跨端可视化数据埋点专利'
        // },
        {
          name: '周老师',
          tag1: '华为开发者专家HDE',
          tag2: '华为鸿蒙学堂机构嘉宾',
          img1: require('../../../assets/coursePage/harmony/box7/周老师-1.png'),
          skill: [
            '12年研发与教学经验', 
            '黑马前端研究院主管',
            '移动端Vant库核心成员',
            '擅长HarmonyOS应用开发Vue/React技术栈开发等前端技术'
          ],
          award: '黑马面试APP鸿蒙版、优医问诊项目课'
        },
        {
          name: '蒋老师',
          tag1: '华为鸿蒙高级开发认证',
          tag2: '华为开发者联盟认证讲师',
          img1: require('../../../assets/coursePage/harmony/box7/蒋老师-1.png'),
          skill: [
            '精通Vue/React/小程序/uni-app/TypeScript/ ArkTS / ArkUI等前端技术', 
            'B站 《Vue2+3 入门到实战课》 播放 95W+',
            '抖音号  "令人脱发的代码" 粉丝 2.6W+',
            '抖音 《听说过css系列教程》 播放 450W+'
          ],
          award: '《鸿蒙原生APP开发课程》、《Vue2+3 入门到实战课》、《听说过CSS系列教程》'
        },
        // {
        //   name: '柴老师',
        //   tag1: '华为鸿蒙高级开发认证',
        //   tag2: '黑马高级课程研究员',
        //   img1: require('../../../assets/coursePage/harmony/box7/柴老师-1.png'),
        //   skill: [
        //     '精通Vue/React/小程序/uni-app/TypeScript/ ArkTS / ArkUI等前端技术', 
        //     'B站 《小兔鲜Vue3项目课》播放44W+',
        //     'B站《React入门到实战2023版》播放 12W+'
        //   ],
        //   award: '《鸿蒙美蔻商城项目》、《小兔鲜Vue3项目课》、《React入门到实战2023版》'
        // },
        {
          name: '苏老师',
          tag1: '华为鸿蒙高级开发认证',
          tag2: '华为开发者联盟认证讲师',
          img1: require('../../../assets/coursePage/harmony/box7/苏老师-1.png'),
          skill: [
            '精通 Vue / React / 小程序 / 云开发 / uni-app / TypeScript / ArkTS / ArkUI等前端技术', 
            'B站《uniapp小兔鲜儿微信小程序项目-Vue3+TS》播放量 29w+',
          ],
          award: '《鸿蒙守护助手项目》、《uniapp小兔鲜儿微信小程序项目》'
        },
        {
          name: '潘老师',
          tag1: '华为开发者专家HDE',
          tag2: '8年开发与教学经验',
          img1: require('../../../assets/coursePage/harmony/box7/潘老师-1.png'),
          skill: [
            '精通Vue/UniApp/TypeScript/ArkTS/ArkU!/Ability组件等前端技术栈', 
            '专利发明：信息处理方法、装置、移动终端及非易失性可读存储介质',
          ],
          award: '信息处理、移动终端等多项国内专利'
        }
      ],
      scroll: 0,
    };
  },
  computed: {
    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  methods: {
    handleScroll() {
      let dom = this.$refs.content.getBoundingClientRect();
      let left = Math.abs(parseInt(dom.x)) / 30;
      if (left >= 1) {
        this.scroll = left;
      } else {
        this.scroll = 0;
      }
    },
    changeCur(index, num) {
      this.show = true;
      if (num == 1) {
        this.cur = index + 6;
      } else {
        this.cur = index;
      }
    },
    openDetail(name) {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
         this.clickZiXun()
      }
      this.mai("鸿蒙-就业课",name,0,null)
    },
  },
};
</script>

<style lang="scss" scoped>
.box7 {
  padding: 80px 0;

  width: 100%;
  background: url("../../../assets/coursePage/harmony/box7/bg.png") no-repeat;
  background-size: cover;

  .word {
    white-space: nowrap;
  }
  ::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }
  .teacher-box {
    margin: 46px auto 0;
    width: 100%;
    overflow-x: auto;
    .box1 {
      width: 1680px;
    }
    .box2 {
      width: 1350px;
    }
    .box1,
    .box2 {
      box-sizing: border-box;
      padding: 74px 0 50px 30px;
      height: 544px;
      display: flex;
      .seat {
        width: 32px;
        flex-shrink: 0;
      }
    }
    .tea-wrapper{
      margin-right: 30px;
			width: 300px;
			height: 420px;
			background: linear-gradient(0deg, #F0F2FF 0%, #E0E6FF 100%);
			box-shadow: 0 0 30px 0 #CCD5FF;
			border-radius: 20px;
			border: 2px solid #F0F2FF;
			img{
				position: relative;
				top: -60px;
				width: 274px;
				height: 360px;
				left: 6px;
			}
			.p-wrapper{
				margin-left: 20px;
				margin-top: -60px;
			}
			.text1{
				font-weight: 600;
				font-size: 28px;
				color: #002BFF;
				margin-bottom: 1px;
			}
			.text2{
				font-size: 22px;
				color: #474D66;
			}
		}
  }
  .teacher-box2 {
    margin-top: 0;
  }

  .pop {
    padding: 48px 48px 58px 48px;

    box-sizing: border-box;
    .pop-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: px;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 52px;
      }
    }
    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }

    .tag-box {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 32px;
      margin-top: 16px;
    }

    .tag {
      margin-right: 16px;
      padding: 0px 16px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      background: #e8f3ff;
      border-radius: 8px;
      margin-top: 16px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #165dff;
    }

    .tag2 {
      height: 44px;
      background: #fff7e8;
      border-radius: 8px;

      color: #ff7d00;
    }

    p {
      position: relative;
      // display: flex;
      margin-bottom: 16px;
      padding-left: 24px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;

      span {
        position: absolute;
        top: 16px;
        left: 0px;
        margin-right: 16px;
        min-width: 8px;
        height: 8px;
        background: #becfff;
        border-radius: 50%;
      }
    }
  }
  .seek-btn {
    margin: 0 auto;
    width: 570px;
    height: 88px;
    background: linear-gradient(0deg, #FF6C47 1%, #FF5A47 100%);
    border-radius: 44px;
    font-weight: 600;
    font-size: 30px;
    color: #FFFFFF;
    line-height: 88px;
    text-align: center;
  }
}
</style>
